var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.667,
    height: 24,
    viewBox: "0 0 26.667 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-attachment",
    transform: "translate(-2.937 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M16.693,5.069a6.979,6.979,0,0,1,9.919,0,7.1,7.1,0,0,1,0,9.989L15.748,26a1,1,0,0,1-1.417,0,1.014,1.014,0,0,1,0-1.427L25.2,13.631a5.07,5.07,0,0,0,0-7.135,4.985,4.985,0,0,0-7.085,0L4.884,19.814a3.042,3.042,0,0,0,0,4.281,2.991,2.991,0,0,0,4.251,0L20,13.155a1.014,1.014,0,0,0,0-1.427,1,1,0,0,0-1.417,0l-8.5,8.562a1,1,0,0,1-1.417,0,1.014,1.014,0,0,1,0-1.427l8.5-8.562a2.991,2.991,0,0,1,4.251,0,3.042,3.042,0,0,1,0,4.281L10.553,25.522a4.985,4.985,0,0,1-7.085,0,5.07,5.07,0,0,1,0-7.135Z",
    transform: "translate(0.937)",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachmentIcon.1486938d1cdc433f6933e8aaef29a8f9.svg";
export { ForwardRef as ReactComponent };